var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppSelect',_vm._b({attrs:{"value":null,"placeholder":"상태 선택","items":_vm.items},on:{"change":_vm.onChange}},'AppSelect',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }